import { render, staticRenderFns } from "./WordBookBadgeDelete.vue?vue&type=template&id=220263a8&scoped=true&"
import script from "./WordBookBadgeDelete.vue?vue&type=script&lang=js&"
export * from "./WordBookBadgeDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220263a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
